import React from 'react';
import Tag from '@atlaskit/tag/removable-tag';

type EnvLozengeProps = {
	label?: string;
};

export function EnvLozenge({ label }: EnvLozengeProps): React.JSX.Element | null {
	return label ? (
		<Tag
			text={label}
			color={label === 'Dev' ? 'standard' : 'orange'}
			isRemovable={false}
			migration_fallback="lozenge"
		/>
	) : null;
}
